import * as React from 'react';
import * as style from '../videoReviews.module.scss';

export const VideoReviewCard = ({ data }) => {
  const [isShown, setIsShown] = React.useState(false);
  return (
    <div className={style.videoReviews__wrapper}>
      <img
        src={data.image}
        alt={""}
        className={style.videoReviews__img}
        onMouseEnter={() => setIsShown(true)}
        onMouseLeave={() => setIsShown(false)}
        onKeyUp={() => setIsShown(true)}
        onKeyDown={() => setIsShown(false)}
        role={"presentation"}
      />
      {!isShown && (
        <span className={style.videoReviews__play}></span>
      )}
      {isShown && (
        <div className={style.videoReviews__info}>
          {
            data.name ?
              <p><strong>{data.name}</strong></p>
              :
              null
          }
          {
            data.age ?
              <p><small>{data.age}</small></p>
              : null
          }
          <p>{data.text}</p>
        </div>
      )}
    </div>
  );
};
